import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { ConversationRoutes } from 'pages/conversations'

export const ClickToTextAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.click_to_text}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
